import { Box, BoxProps, FormControl } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { DropzoneArea } from 'react-mui-dropzone';
import { sharedColors } from '../../utils/Style';

export const excelMimeTypes =
  '.xls, .xlsx, application/vnd.ms-excel, ' +
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

type FileDropzoneProps = Omit<BoxProps, 'onChange'> & {
  onChange: (file?: File) => void;
};

export const FileDropzone = ({ onChange, ...props }: FileDropzoneProps) => {
  const classes = useStyles();

  const handleFile = (file: File[]) => {
    onChange(file[0]);
  };

  return (
    <Box
      component='div'
      sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
      {...props}
    >
      <FormControl component='fieldset' sx={{ display: 'flex', flexGrow: 1 }}>
        <DropzoneArea
          dropzoneClass={classes.dropzone}
          dropzoneText='Yüklenecek dosyayı seçiniz'
          acceptedFiles={[excelMimeTypes]}
          filesLimit={1}
          maxFileSize={100240000}
          showFileNames
          onChange={handleFile}
        />
      </FormControl>
    </Box>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    dropzone: {
      position: 'relative',
      padding: 2,
      minHeight: '150px',
      backgroundColor: sharedColors.gray2,
      border: 'dashed',
      borderColor: sharedColors.gray3,
      cursor: 'pointer',
    },
    '@global': {
      '.MuiDropzonePreviewList-removeButton': {
        top: '60px !important',
        right: '-10px !important',
      },
    },
  }),
);
